import axios from "axios";

export default {
  getParameters({ commit, rootGetters }) {
    commit("loading", true);
    axios
      .get("/json/cross-selling-transactional/getParameters")
      .then(({ data }) => {
        commit("enabledRules", data.data.rules);
        commit("cooldown", data.data.cooldown);
        commit("cooldownTypeId", data.data.cooldownTypeId);
        commit(
          "dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct",
          data.data.dontSentIfCustomerHasAlreadyPurchasedRecomendatedProduct
        );
        commit(
          "dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId",
          data.data.dontSentIfCustomerHasAlreadyPurchasedRecomendatedProductTypeId
        );
        commit("numberOfRulesSentAfterAction", data.data.numberOfRulesSentAfterAction);
        commit("numberOfRulesSentAfterActionId", data.data.numberOfRulesSentAfterActionId);
        commit("trackerProductCategories", data.data.trackerProductCategories);
        commit("deletedPagesCount", data.data.deletedPagesCount);
      })
      .catch(() => {
        commit("error", true);
      })
      .finally(() => {
        commit("loading", false);
      });
  },
  getDisabledRules({ commit, rootGetters }, { page }) {
    axios
      .post("/cross-selling-transactional/getDeletedRulesList", {
        page: page,
      })
      .then(({ data }) => {
        commit("disabledRules", data.rules);
      });
  },
  addRule({ commit, rootGetters }, { rule }) {
    commit("addRule", rule);
  },
  disableRule({ commit, rootGetters }, { orderIndex }) {
    commit("disableRule", orderIndex);
  },
  enableRule({ commit, rootGetters }, { orderIndex }) {
    commit("enableRule", orderIndex);
  },
  editRule({ commit, state }, { rule }) {
    const index = state.enabledRules.findIndex((enabledRule) => enabledRule.orderIndex === rule.orderIndex);
    commit("editRule", { index, rule });
  },
};
